<template>
    <app-pane formTitle="Let's get started">
      <template v-slot:left-side>
        <div id='right-side'>
          <b-form-group v-slot="{ ariaDescribedby }">
            <div class='form-label'>
              {{ stumpingOnly ? "How many stumps need work?" : "How many trees or stumps need work?" }}
            </div>

            <b-form-radio v-model.number="amount" :aria-describedby="ariaDescribedby" name="some-radios" value=1 class='quantity-radio'>One</b-form-radio>
            <b-form-radio v-model.number="amount" :aria-describedby="ariaDescribedby" name="some-radios" value=2 class='quantity-radio'>Two</b-form-radio>
            <b-form-radio v-model.number="amount" :aria-describedby="ariaDescribedby" name="some-radios" value=3 class='quantity-radio'>Three</b-form-radio>
          </b-form-group>
        </div>
      </template>

      <template v-slot:right-side>
        It couldn't be simpler to get an estimate. Just a few simple questions about your job, and we'll take care of the rest.

        <br /><br />

        Let's start with the number of trees or stumps you need work on.

        <br /><br />

        If your job requires more than three trees or stumps, please contact us directly so we can set up a more detailed consultation.
      </template>

      <template v-slot:controls>
        <app-buttons :standalone='standalone'></app-buttons>
      </template>

    </app-pane>
</template>

<script>
import Pane from '@/components/onboarding/pane';
import FormButtons from '@/components/onboarding/widgets/formButtons';

export default {
  components: {
    'app-pane' : Pane,
    'app-buttons': FormButtons
  },
  props: {
    value: {
      type: Number,
      default: 1
    },
    stumpingOnly: {
      type: Boolean,
      default: false
    },
    standalone: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      amount: this.value
    }
  },
  watch: {
    amount() {
      this.$emit('input', this.amount);
    }
  }
}
</script>

<style>
.quantity-radio {
  margin-bottom: 8px;

  border: 1px solid var(--main-color);
  border-radius: 5px;
  padding: 8px 12px 8px 36px;
}

.quantity-radio:hover {
  background-color: #efefef;
}

.quantity-radio .custom-control-label {
  width: 100%;
  font-weight: 600;
  cursor: pointer;
}

.quantity-radio .custom-control-label::before,
.quantity-radio .custom-control-label::after {
  top: 50%;
  transform: translateY(-50%);
}

input[type='radio']:checked:after {
  width: 15px;
  height: 15px;
  border-radius: 15px;
  top: -2px;
  left: -1px;
  position: relative;
  background-color: var(--main-color);
  content: '';
  display: inline-block;
  visibility: visible;
  border: 2px solid white;

  padding: 4px;
}
</style>
